/*
 * @Author: shiguang
 * @Date: 2023-04-28 11:51:00
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-30 13:30:27
 * @Description: interceptors
 */
import { useLocation } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import queryString from 'query-string';
import { debounce } from 'lodash';
import axios from 'axios';
import { api, apiInstanceList } from '@/service';
import { getStationCode } from '@/i18n/init';
import apiCode from '@/i18n/locales/apiCode.json';
import { getLang } from '@/i18n/i18n';
import { ShopLocalstorage, TokenSignLocal, loginEnv, logout } from './login';

// const graify = gray(serviceConfig.baseURL);
/** 请求接口时请求头需要加的东西 */
export const apiTag = '20240701-korea-store';

// 项目文件根目录
const baseURL = process.env.REACT_APP_PUBLIC_PATH;
const isProd = process.env.NODE_ENV === 'production';
const axiosV = axios.create({
	timeout: 3 * 60 * 1000,
	baseURL
});

// 请求是否刷新资源
const validVersion = debounce(() => {
	const curVersion = window.curVersion ?? { time: 0 };
	let request = false;
	if (Date.now() > curVersion.time + 10 * 60 * 1000 && !request) {
		request = true;
		axiosV.get(`/compilerInfo.json?t=${Date.now()}`).then((res) => {
			request = false;
			if (
				curVersion.version &&
				curVersion.version !== res?.data?.compilterTime
			) {
				requestAnimationFrame(() => {
					window.location.reload();
				});
			}
			curVersion.version = res?.data?.compilterTime;
			curVersion.time = Date.now();
			window.curVersion = curVersion;
		});
	}
}, 1000);
declare module 'axios' {
	interface AxiosRequestConfig {
		/** 使用mock */
		useMock?: boolean;
		isNotShowToast?: boolean;
	}
}
export interface User {
	loginInfo: {
		userId: string;
		username: string;
	};
	userInfo: {};
	auth: never[];
	token: string;
}
/**
 * 从 localStorage 取 token
 * @returns
 */
export const getLocalStorageToken = () => {
	const tokenStr = window.localStorage.getItem('production_route/token');
	console.log(tokenStr, '---production_route/token--');
	if (!tokenStr) return;
	try {
		const token = JSON.parse(tokenStr).val as string;
		console.log(tokenStr, '---JSON.parse ---production_route/token--');
		return token;
	} catch (e) {
		return undefined;
	}
};

/**
 * 从 localStorage 取 token
 * @returns
 */
export const getCookieToken = () => {
	const tokenStr = localStorage.getItem(TokenSignLocal);
	try {
		// 可能是一个 带 val 的值，从 client 那边设置的
		const token = (JSON.parse(tokenStr || '') || {}).val as string;
		console.log(
			token,
			'---Cookie.get(TokenSignCookie)=======getCookieToken--'
		);
		return token;
	} catch (e) {
		return tokenStr;
	}
};

/**
 * merge Token
 * 优先取 cookie 里面的 token
 * @returns
 */
export const getMergedToken = () => {
	return getCookieToken() || getLocalStorageToken() || '';
};

export const getToken = () => {
	return getMergedToken();
};

export const getShopId = () => {
	const shopStr = window.localStorage.getItem(ShopLocalstorage);
	if (!shopStr) return;
	try {
		const shopId = JSON.parse(shopStr).val as string;
		return shopId;
	} catch (e) {
		return undefined;
	}
};

/**
 * admin 端
 */
export const getUserInLocal = () => {
	const usrStr = window.localStorage.getItem('user');
	if (!usrStr) return;
	try {
		const user = JSON.parse(usrStr).user as User;
		return user;
	} catch (e) {
		return undefined;
	}
};
const stationCode = getStationCode();
/** 登录方法 */
export const goToLogin = async () => {
	logout();
	const path = window.location.href;
	const { channel } = queryString.parse(window.location.search);
	const _env = process.env.REACT_APP_ENV as loginEnv;
	const url = encodeURIComponent(path);

	let _searchObj = {} as Record<string, any>;
	if (channel) {
		_searchObj['channel'] = channel;
	}
	if (window.location.port || _env === 'prod1') {
		_searchObj = {
			..._searchObj
		};
		const _search = queryString.stringify(_searchObj);
		// 跳转登陆页面（目前先写本地的登录）
		window.location.href = `/h5/dev/login?` + _search;
		return;
	}
	_searchObj = {
		..._searchObj
	};
	const _search = queryString.stringify(_searchObj);
	if (_env === 'test') {
		const envArr = window.location.hostname.split('s.theckb.com');
		// 跳转登陆页面（目前先写本地的登录）
		window.location.href =
			`https://${envArr[0]}s.theckb.com/login_h5?` + _search;
	}
	if (_env === 'pre') {
		// 跳转登陆页面（目前先写本地的登录）
		window.location.href = `https://pre-s.theckb.com/login_h5?` + _search;
	}
	if (_env === 'prod') {
		// 跳转登陆页面（目前先写本地的登录）
		window.location.href = `https://s.theckb.com/login_h5?` + _search;
	}
};

const whiteApicode = ['33000000'];
const whiteSuccessResponseCode = ['24220002'];

apiInstanceList.forEach((item) => {
	// 请求拦截
	item.instance.instance.interceptors.request.use(async function (config) {
		isProd && validVersion();
		config.headers = config.headers ?? {};
		const isPost = ['POST', 'post'].includes(config.method!);
		const token = getToken();
		const shopId = getShopId();

		if (token) {
			config.headers['X-Authtoken'] = token;
		}
		config.headers['X-Authshopid'] = shopId ?? '';
		if (isPost) {
			if (!config.data && config.params) {
				config.data = config.params;
			}
			config.params = {};
			config.headers['Content-Type'] = 'application/json';
		}
		if (stationCode) {
			config.headers['X-stationCode'] = stationCode;
		}
		config.headers['X-GRAY-TAG'] = apiTag;
		config.headers['X-Platform'] = 'H5';
		// 应用名称
		config.headers['X-Appname'] = 'ckb-client-h5';
		// config.headers['X-GRAY-TAG'] = apiConfig.requestEnv;
		if (config['useMock']) {
			const queryPath = (config.baseURL! + config.url!).replace(
				// eslint-disable-next-line no-useless-escape
				/https{0,1}:\/\/[^\/]+/,
				''
			);
			config.headers['Mock-Query-Path'] = queryPath;
			config.baseURL =
				'http://192.168.201.56:8000/functions/v1/mockapi' + queryPath;
			config.url = '';
		}
		// await graify(config);
		return config;
	});

	// 返回拦截
	item.instance.instance.interceptors.response.use(
		function (response) {
			if (response.data.code === '10000000') {
				goToLogin();
				return Promise.reject(response.data.msg);
			}

			if (response.config.responseType === 'blob') {
				return response;
			}

			if (whiteSuccessResponseCode.includes(response?.data?.code)) {
				return Promise.reject(response);
			}

			if (!response.data.success) {
				// 获取语言
				const lang = getLang();
				/** 翻译后的错误信息, 若是不存在，则展示中文 */
				const errMessaage =
					apiCode[lang][response.data?.code] ??
					apiCode['zh_CN'][response.data?.code];
				const apiCodeArr = Object.keys(apiCode[lang]) ?? [];

				if (apiCodeArr.length <= 0) {
					return Promise.reject(response.data.msg);
				}
				// 白名单apicode
				if (whiteApicode.includes(response.data?.code)) {
					Toast.show(errMessaage);
					return Promise.reject(errMessaage);
				}
				// 默认false，
				if (!response.config.isNotShowToast) {
					const message = errMessaage ?? apiCode[lang]['noMatch'];
					Toast.show(message);
				}

				// 如果有apicode，且该错误码包含在apicode中，且自定义toast 则透出msg字段
				if (
					apiCodeArr.length > 0 &&
					apiCodeArr.includes(response.data?.code) &&
					response.config.isNotShowToast
				) {
					const _response = {
						...response,
						data: {
							...response.data,
							msg: errMessaage ?? response.data.msg
						}
					};
					return Promise.reject(_response);
				}

				return Promise.reject(response.data.msg);
			}
			if (response.data?.code === '0' && response.data.success === true) {
				return Promise.resolve(response);
			}
			// return response;
			// message.error(String(response.data.msg));
			return Promise.reject(response.data.msg);
		},
		function (error) {
			// console.log(444444, error);
			// message.error(window._$m.t('请求错误：') + String(error));
			return Promise.reject(error);
		}
	);
});

export const request = api;
